<template>
    <div>
        <div class="modale opened" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-header">
                    <img src="../assets/salestrekker.png" alt="">
                </div>
                <div class="modal-body">
                    <h4 v-if="!inProgres">{{newContactsLength}} new contact(s) will be added.</h4>
                    <h4 v-if="inProgres">Creating {{newContactsLength}} new contact(s), please wait ...</h4>
                </div>
                <div class="modal-footer">
                    <div v-if="!inProgress">
                        <button class="btn" @click="ok()">OK</button>
                        <button class="btn" @click="close()">Close</button>
                    </div>
                    <div v-if="inProgress" class="sync-loader">
                        <preloader></preloader>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Preloader from './Preloader';

    export default {
        props: ['newContactsLength'],
        components: {
            preloader: Preloader
        },
        data () {
            return {
                inProgress: false
            };
        },
        methods: {
            close () {
                this.$emit('close', false);
            },
            ok () {
                this.inProgres = true;
                this.$emit('ok');
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/SyncContactsModal.vue